(ns machtfit.startpage.statics
  (:require [machtfit.core :as machtfit]
            [machtfit.startpage.icons :as icons]))

(def pages
  {:order-list {:name {:de "Buchungen"
                       :en "Bookings"}
                :nav-image-url (machtfit/static "img/shopping-bag.svg")
                :path "/account/orders/"}
   :memberships {:name {:de "Mitgliedschaften"
                        :en "Memberships"}
                 :nav-image-url (machtfit/static "img/image-user-check.svg")
                 :path "/account/memberships/"}
   :health-expenses {:name {:de "Erstattungen"
                            :en "Health Expenses"}
                     :path "/account/health-expenses/"
                     :nav-image-url (machtfit/static "img/file.svg")}
   :favorites {:name {:de "Favoriten"
                      :en "Favorites"}
               :route-data {:id :catalog
                            :filter {:area :all
                                     :favorites true}}
               :nav-image-url (machtfit/static "img/favorite.svg")}
   :bgm-info {:name {:de "BGM Info"
                     :en "BGM Info"}
              :url :content:index-bgm-info
              :nav-image-url (machtfit/static "img/newspaper.svg")}

   :profile-view {:name {:de "Konto"
                         :en "User account"}
                  :path "/account/profile/"}
   :cockpit {:name {:de "CHS-Cockpit"
                    :en "CHS-Cockpit"}
             :url :dashboard:index}
   :help {:name {:de "Hilfe"
                 :en "Help"}
          :url :faq
          :target "_blank"}
   :account-health-profile {:name {:de "Mein Gesundheitsprofil"
                                   :en "My health profile"}
                            :path "/account/health-profile/"
                            :nav-image-url (machtfit/static "img/dumbbell.svg")}
   :account-activity {:name {:de "Meine Aktivität"
                             :en "My activity"}
                      :path "/account/activity/"
                      :nav-image-url (machtfit/static "img/badge.svg")}
   ;; A path rather than `[:urls]`, for the reason `footer.cljs#migrated-link` gives.
   :tell-a-colleague {:name {:de "Kolleg:innen einladen"
                             :en "Invite colleagues"}
                      :path "/account/tell-a-colleague/"}
   :logout {:name {:de "Abmelden"
                   :en "Log out"}
            :url :customer:logout}})

(def external-pages
  {:magazine {:name {:de "Magazin"
                     :en "Magazine"}
              :url :content:index-magazin
              :nav-image-url (machtfit/static "img/navigation/Navi_Magazin_530X300.jpg")}
   :bgm-info {:name {:de "BGM Info"
                     :en "BGM Info"}
              :url :content:index-bgm-info
              :nav-image-url (machtfit/static "img/navigation/Navi_BGM_Info_530X300.jpg")}
   :contact {:name {:de "Kontakt"
                    :en "Contact"}
             :url :contact}
   :help {:name {:de "Hilfe"
                 :en "Help"}
          :url :faq
          :target "_blank"}
   :profile-view {:name {:de "Mein Konto"
                         :en "My user account"}
                  :url :customer:profile-view}
   :logout {:name {:de "Ausloggen"
                   :en "Log out"}
            :url :customer:logout
            :icon icons/logout}
   :cockpit {:name {:de "CHS-Cockpit"
                    :en "CHS-Cockpit"}
             :url :dashboard:index}
   :privacy-policy {:name {:de "Datenschutz"
                           :en "Data protection"}
                    :url :privacy-policy}
   :terms {:name {:de "AGB"
                  :en "Terms and conditions"}
           :url :terms}})

(def product-categories #{"Ergonomische Ausstattung"
                          "Ernährungskuren"
                          "Gesunde Fertiggerichte"
                          "Körperanalyse/Tests"
                          "Lebensmittel & Kochboxen"
                          "Nahrungsergänzungsmittel"
                          "Orthopädische Hilfsmittel"
                          "Regenerationszubehör"
                          "Schlafprodukte"
                          "Sporternährung"
                          "Trainingszubehör"
                          "Wearables & Smartwatches"})

(def filter-presets
  (let [from-home-categories #{"Mentale Gesundheit"
                               "Aqua Fitness"
                               "Autogenes Training"
                               "Beckenbodentraining"
                               "Ernährungsberatung"
                               "Faszientraining"
                               "Fitnesstraining"
                               "Fitnessstudio"
                               "Fußball"
                               "Gehwettbewerb"
                               "Gesundheitstraining"
                               "Kampfsport"
                               "Klettern/Bouldern"
                               "Körperanalyse/Tests"
                               "Laufen/Nordic Walking"
                               "Lebensmittel & Kochboxen"
                               "Massage"
                               "Paddling"
                               "Personal Training"
                               "Pflege"
                               "Pilates"
                               "Progressive Muskelentspannung"
                               "QiGong"
                               "Raucherentwöhnung"
                               "Rückenfitness"
                               "Schlafen"
                               "Schwimmen"
                               "Spinning / Radfahren"
                               "Tai Chi"
                               "Tennis/Squash/Badminton"
                               "Wellness"
                               "Yoga"
                               "Zumba/Tanzen"}]
    {:all-offers {:name "Alle Angebote"
                  :nav-image-url (machtfit/static "img/navigation/Navi_Alle_Angebote_530X300.jpg")
                  :filter {:area :all}}
     :machtfit-area {:filter {:area :machtfit}}
     :machtfit-area-subsidy {:filter {:area :machtfit :subsidy true}}
     :from-home {:name "Von zu Hause aus"
                 :filter {:categories from-home-categories
                          :area :machtfit
                          :sort-by :recommended
                          :online true}}
     :company-area {:filter {:area :company}}
     :favorites {:name "Favoriten"
                 :filter {:area :all
                          :favorites true}}
     :exercise {:name "Bewegung"
                :nav-image-url (machtfit/static "img/navigation/Navi_Bewegung_530X300.jpg")
                :desc "Von A wie Aquafitness bis Z wie Zumba: Starte durch mit unseren Bewegungskursen. Zum Auspowern, Fitbleiben und Spaßhaben! Tipps vom Fitnesscoach, Trainingspläne und vieles mehr liest du in unseren Beiträgen."
                :filter {:categories #{"Aqua Fitness"
                                       "Ballsport"
                                       "Beckenbodentraining"
                                       "Crossfit"
                                       "EMS Training"
                                       "Faszientraining"
                                       "Fitnessstudio"
                                       "Fitnesstraining"
                                       "Gesundheitstraining"
                                       "HIIT Training"
                                       "Kampfsport"
                                       "Klettern/Bouldern"
                                       "Laufen/Nordic Walking"
                                       "Paddling"
                                       "Personal Training"
                                       "Pilates"
                                       "Rückenfitness"
                                       "Schwimmen"
                                       "Spinning / Radfahren"
                                       "Tennis/Squash/Badminton"
                                       "Trainingszubehör"
                                       "Wearables & Smartwatches"
                                       "Yoga"
                                       "Zumba/Tanzen"
                                       "Tai Chi"
                                       "QiGong"
                                       "Gesundheitsreisen"
                                       "Fußball"
                                       "Bewegungsschulung"}

                         :area :machtfit}}
     :nutrition {:name "Ernährung"
                 :nav-image-url (machtfit/static "img/navigation/Navi_Ernährung_530X300.jpg")
                 :desc "Eine gesunde, abwechslungsreiche Ernährung ist ein wichtiger Schlüssel zum Wohlbefinden. Nur: Im stressigen Arbeitsleben ist das gar nicht immer so einfach. Unsere Kurse, Tipps und Rezepte zeigen dir die besten Wege aus der „Currywurst-Falle“."
                 :filter {:categories #{"Ernährungsberatung"
                                        "Ernährungskuren"
                                        "Gesunde Fertiggerichte"
                                        "Kochkurse"
                                        "Lebensmittel & Kochboxen"
                                        "Nahrungsergänzungsmittel"
                                        "Sporternährung"}
                          :area :machtfit
                          :distance-home true
                          :distance-work true}}
     :healthy-living {:name "Gesundheit"
                      :nav-image-url (machtfit/static "img/navigation/Navi_Gesund_Leben_530X300.jpg")
                      :desc "Sich selbst und seinem Körper etwas Gutes tun: Dazu gibt es viele Möglichkeiten. Wie du gute Vorsätze in die Tat umsetzt, erfährst du in unseren Beiträgen – und noch besser live in unseren Gesundheitskursen."
                      :filter {:categories #{"Mentale Gesundheit"
                                             "Bewegungsschulung"
                                             "Ergonomische Ausstattung"
                                             "Gesundheitsreisen"
                                             "Gesundheitstraining"
                                             "Hypnose"
                                             "Körperanalyse/Tests"
                                             "Meditation"
                                             "Orthopädische Hilfsmittel"
                                             "Persönlichkeitsentwicklung"
                                             "Raucherentwöhnung"
                                             "Schlafen"
                                             "Schlafprodukte"}
                               :area :machtfit
                               :distance-home true
                               :distance-work true}}
     :relaxation {:name "Entspannung"
                  :nav-image-url (machtfit/static "img/navigation/Navi_Entspannung_530X300.jpg")
                  :desc "Der Alltag fordert dir viel ab? Mit den richtigen Entspannungstechniken und Anti-Stress-Strategien bleibst du relaxt und leistungsfähig. Unsere Beiträge erklären, wie's geht – oder buche gleich den passenden Kurs."
                  :filter {:categories #{"Autogenes Training"
                                         "Massage"
                                         "Progressive Muskelentspannung"
                                         "QiGong"
                                         "Regenerationszubehör"
                                         "Tai Chi"
                                         "Wellness"
                                         "Yoga"
                                         "Mentale Gesundheit"
                                         "Schlafprodukte"
                                         "Körperanalyse/Tests"
                                         "Schlafen"
                                         "Gesundheitsreisen"
                                         "Hypnose"
                                         "Meditation"
                                         "Pilates"
                                         "Faszientraining"}
                           :area :machtfit}}
     :online {:name "Online-Angebote"
              :filter {:product-types #{"online"}
                       :area :machtfit}}
     :health-travel {:name "Reisen"
                     :filter {:categories #{"Gesundheitsreisen"}
                              :online true
                              :area :machtfit}}
     :price-advantage {:name "Angebote mit machtfit Preisvorteil"
                       :filter {:mf-offer true
                                :area :machtfit}}
     :exclusive {:name "Exklusiv bei machtfit"
                 :filter {:area :machtfit :labels #{"Exklusiv"}}}
     :fitness-products {:name "Fitnessprodukte"
                        :filter {:area :machtfit
                                 :labels #{"Fitnessprodukte"}
                                 :sort-by :recommended}}
     :popular {:name "Beliebte Angebote"
               :filter {:area :machtfit :labels #{"Beliebt"}}}
     :new {:name "Neu eingetroffen"
           :filter {:online true
                    :categories from-home-categories
                    :distance-home false
                    :distance-work false
                    :sort-by :date-published
                    :area :machtfit}}
     :prevention {:name "Angebote zur Prävention"
                  :filter {:online true
                           :categories from-home-categories
                           :sort-by :recommended
                           :estg3no34-subsidizable? true
                           :area :machtfit}}
     :fit-at-home {:name "Fit fühlen"
                   :filter {:online true
                            :area :machtfit
                            :categories #{"Fitnesstraining"
                                          "Rückenfitness"
                                          "Faszientraining"
                                          "Ballsport"
                                          "EMS Training"
                                          "Crossfit"
                                          "HIIT Training"
                                          "Pilates"
                                          "Trainingszubehör"
                                          "Wearables & Smartwatches"
                                          "Yoga"}}}
     :relax-at-home {:name "Entspannung finden"
                     :filter {:online true
                              :area :machtfit
                              :categories #{"Mentale Gesundheit"
                                            "Wellness"
                                            "Autogenes Training"
                                            "Meditation"
                                            "Progressive Muskelentspannung"
                                            "Regenerationszubehör"
                                            "Schlafen"}}}

     :recommendations {:filter {:area :machtfit
                                :sort-by :recommended}}
     :recommendations-subsidy {:filter {:area :machtfit
                                        :subsidy true
                                        :sort-by :recommended}}
     :nutrition-at-home {:name "Gesund essen"
                         :filter {:online true
                                  :area :machtfit
                                  :categories #{"Ernährungsberatung"
                                                "Kochkurse"
                                                "Lebensmittel & Kochboxen"
                                                "Nahrungsergänzungsmittel"
                                                "Ernährungskuren"
                                                "Gesunde Fertiggerichte"
                                                "Sporternährung"}}}}))

(def area->base-filter
  {:company (-> filter-presets :company-area :filter)
   :machtfit (-> filter-presets :machtfit-area :filter)})

(defn category->topic [category]
  (case category
    "Mentale Gesundheit" [:healthy-living :relaxation]
    "Aqua Fitness" [:exercise]
    "Autogenes Training" [:relaxation]
    "Ballsport" [:exercise]
    "Beckenbodentraining" [:exercise]
    "Bewegungsschulung" [:healthy-living :exercise]
    "Crossfit" [:exercise]
    "EMS Training" [:exercise]
    "Ergonomische Ausstattung" [:healthy-living]
    "Ernährungsberatung" [:nutrition]
    "Ernährungskuren" [:nutrition]
    "Faszientraining" [:exercise :relaxation]
    "Fitnesstraining" [:exercise]
    "Gesunde Fertiggerichte" [:nutrition]
    "Gesundheitsreisen" [:health-travel :exercise :relaxation]
    "Gesundheitstraining" [:exercise]
    "HIIT Training" [:exercise]
    "Hypnose" [:healthy-living :relaxation]
    "Kampfsport" [:exercise]
    "Klettern/Bouldern" [:exercise]
    "Kochkurse" [:nutrition]
    "Körperanalyse/Tests" [:healthy-living :relaxation]
    "Laufen/Nordic Walking" [:exercise]
    "Lebensmittel & Kochboxen" [:nutrition]
    "Massage" [:relaxation]
    "Meditation" [:healthy-living :relaxation]
    "Nahrungsergänzungsmittel" [:nutrition]
    "Orthopädische Hilfsmittel" [:healthy-living]
    "Paddling" [:exercise]
    "Personal Training" [:exercise]
    "Persönlichkeitsentwicklung" [:healthy-living]
    "Pilates" [:exercise :relaxation]
    "Progressive Muskelentspannung" [:relaxation]
    "QiGong" [:relaxation :exercise]
    "Raucherentwöhnung" [:healthy-living]
    "Regenerationszubehör" [:relaxation]
    "Rückenfitness" [:exercise]
    "Schlafen" [:healthy-living :relaxation]
    "Schlafprodukte" [:healthy-living :relaxation]
    "Schwimmen" [:exercise]
    "Spinning / Radfahren" [:exercise]
    "Sporternährung" [:nutrition]
    "Tai Chi" [:relaxation :exercise]
    "Tennis/Squash/Badminton" [:exercise]
    "Trainingszubehör" [:exercise]
    "Wearables & Smartwatches" [:exercise]
    "Wellness" [:relaxation]
    "Yoga" [:exercise :relaxation]
    "Zumba/Tanzen" [:exercise]
    "Fußball" [:exercise]
    [:other]))

(def category-translations
  {"Activity Deals" "Activity Deals"
   "Mentale Gesundheit" "Mental Health"
   "Aqua Fitness" "Aqua fitness"
   "Autogenes Training" "Autogenic training"
   "Ballsport" "Ball sports"
   "Beckenbodentraining" "Pelvic floor exercise"
   "Bewegungsschulung" "Movement training"
   "Crossfit" "Crossfit"
   "Digital Deals" "Digital Deals"
   "EMS Training" "EMS training"
   "Ergonomische Ausstattung" "Ergonomic equipment "
   "Ernährungsberatung" "Nutrition consultation"
   "Ernährungskuren" "Nutritional regime"
   "Faszientraining" "Fascia training"
   "Firmenintern" "Company intern"
   "Fitnesstraining" "Fitness training"
   "Fitnessstudio" "Gym"
   "Fußball" "Football"
   "Gehwettbewerb" "Activity Challenge"
   "Gesunde Fertiggerichte" "Healthy instant meals"
   "Gesundheitsreisen" "Health trips"
   "Gesundheitstraining" "Health training"
   "HIIT Training" "HIIT training"
   "Hypnose" "Hypnosis"
   "Kampfsport" "Combat sport"
   "Klettern/Bouldern" "Climbing/Bouldering"
   "Kochkurse" "Cooking course"
   "Körperanalyse/Tests" "Body analysis/tests"
   "Laufen/Nordic Walking" "Running/Nordic walking"
   "Lebensmittel & Kochboxen" "Food & Meal kits"
   "Massage" "Massage"
   "Meditation" "Meditation"
   "Nahrungsergänzungsmittel" "Nutritional supplement"
   "Orthopädische Hilfsmittel" "Orthopedic products"
   "Paddling" "Paddling"
   "Personal Training" "Personal training"
   "Persönlichkeitsentwicklung" "Personal development"
   "Pilates" "Pilates"
   "Progressive Muskelentspannung" "Progressive muscle relaxation"
   "QiGong" "Qi Gong"
   "Raucherentwöhnung" "Quitting smoking"
   "Regenerationszubehör" "Regeneration equipment"
   "Rückenfitness" "Back fitness"
   "Schlafen" "Sleeping"
   "Schlafprodukte" "Sleep products"
   "Schwimmen" "Swimming"
   "Spinning / Radfahren" "Spinning / Cycling"
   "Sporternährung" "Sports nutrition"
   "Tai Chi" "Tai Chi"
   "Tennis/Squash/Badminton" "Tennis/Squash/Badminton"
   "Trainingszubehör" "Trainings equipment"
   "Wearables & Smartwatches" "Wearables & Smartwatches"
   "Wellness" "Wellness"
   "Yoga" "Yoga"
   "Zumba/Tanzen" "Zumba/Dancing"})
